import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgSquareDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};
export const SvgSquare = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" {...props}>
    <rect
      width={16}
      height={16}
      x={4}
      y={4}
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={2}
      rx={3}
    />
  </svg>
));
